import { initErrorHandling, reportError } from '~/utils/errorReporter';

initErrorHandling();
window.reportError = reportError;
